import { Dispatch } from "redux";
import { Auth2FaVerificationResponse } from "../../../models/auth2FaData";
import { auth2FaService } from "../../../api/index";
import {
  Auth2FaActionTypes,
  AUTH_2FA_VERIFICATION_SUCCESS,
  AUTH_2FA_VERIFICATION_FAILURE,
  AUTH_2FA_VERIFICATION_REQUEST,
  Auth2FaVerificationSuccessAction,
  Auth2FaVerificationFailureAction,
  Auth2FaVerificationRequestAction,
} from "./types";
import { handleSuccessfulLogin } from "../../auth/actions";

/**
 * Action to verify the 2FA code.
 * @param {string} user_id - The ID of the user.
 * @param {string} code - The 2FA code to verify.
 * @returns {Function} A function that dispatches actions based on the API response.
 * @throws {Error} If the verification fails, it dispatches a failure action.
 */
export function verify2FaCode(
  user_id: string,
  code: string,
  dispatch_: Dispatch,
  from: string | null
) {
  return (dispatch: Dispatch<Auth2FaActionTypes>) => {
    dispatch(verify2FaRequest());
    auth2FaService
      .verify2FaCode(user_id, code)
      .then((response) => {
        dispatch(verify2FaSuccess(response));
        handleSuccessfulLogin(dispatch_, from);
      })
      .catch(() => {
        dispatch(verify2FaFailure());
      });
  };
}

/**
 * Action creator for requesting 2FA verification.
 * @returns {Auth2FaVerificationRequestAction} The action object.
 */
export function verify2FaRequest(): Auth2FaVerificationRequestAction {
  return {
    type: AUTH_2FA_VERIFICATION_REQUEST,
  };
}

/**
 * Action creator for failed 2FA verification.
 * @returns {Auth2FaVerificationFailureAction} The action object.
 */
export function verify2FaFailure(): Auth2FaVerificationFailureAction {
  return {
    type: AUTH_2FA_VERIFICATION_FAILURE,
  };
}

/**
 * Action to load the 2FA verification success response.
 * @param {Auth2FaVerificationData} data - The data received from the 2FA verification.
 * @returns {Auth2FaVerificationSuccessAction} The action object.
 */
export function verify2FaSuccess(
  data: Auth2FaVerificationResponse
): Auth2FaVerificationSuccessAction {
  return {
    type: AUTH_2FA_VERIFICATION_SUCCESS,
    detail: data,
  };
}
